// this reducer stores only the data of the home tab, used for filtering hunts
// and showing the hunt map

import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  //treasure data
  homeView: 'list', //[list, map]
  homeSearchText: false,
  homeActiveSearch: false,
};

const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    updateHomeView(state, {payload: homeView}) {
      state.homeView = homeView;
    },
    updateHomeSearchText(state, {payload: homeView}) {
      state.homeSearchText = homeView;
    },
    updateHomeActiveSearch(state, {payload: homeView}) {
      state.homeActiveSearch = homeView;
    },
    resetHomeView(state) {
      state = {...initialState};
      return state;
    },
    updateHomeState(state, {payload: data}) {
      const newReducerState = {
        ...state,
        ...(data || {}),
      };
      console.log({newReducerState});
      return newReducerState;
    },
  },
});

export const {
  updateHomeView,
  updateHomeSearchText,
  updateHomeActiveSearch,
  updateHomeState,
  resetHomeView,
} = homeSlice.actions;

export default homeSlice.reducer;
